<template>
    
<div>
    <div class="row justify-content-between align-items-end">
        <div class="col-md-6">
            <div v-if="pagination">
                <img src="../assets/logo.jpg" alt="" class="img-pdf">
            </div>
            <p>{{invoice.header}}</p>
        </div>
        <div class="col-md-6">
            <h2 class="text-right">Invoice</h2>
            <h5 class="text-right">{{invoice.invoice_date}}</h5>
            <h6 class="mt-3"> Invoice Crédit Terms - {{invoice.terms}}</h6>
            <p class="font-weight-bold">Customer # 0000 <br> Invoice # {{invoice.invoice_number}} </p>
        </div>
    </div>
    <div class="row justify-content-between my-5">
        <div class="col-md-6 mb-invoice">
            <b-card border-variant="info" header="Submitted To:" align="left" style="height: 100%">
                <b-card-text>{{invoice.submitted_to}}</b-card-text>
            </b-card>
        </div>
        <div class="col-md-6">
            <b-card border-variant="info" header="Submitted By:" align="left" style="height: 100%">
                <b-card-text>{{invoice.submitted_by}}</b-card-text>
            </b-card>
        </div>
    </div>
    <!-- Table - Invoice Items -->
    <div class="overflow-auto">
        <b-table outlined hover small :items="invoice_items" :fields="columns" :per-page="perPage"
            :current-page="currentPage">

            <!-- Currency format price -->
            <template v-slot:cell(price)="{ item }">
                ${{ item.price }}
            </template>

            <!-- Currency format total-->
            <template v-slot:cell(total)="{ item }">
                ${{ item.total }}
            </template>

        </b-table>

        <div class="d-flex justify-content-between">
            <!-- Total Records -->
            <p class="text-left"><b>Total Records: </b>{{ rows }}</p>
            <!-- Total Invoice -->
            <p class="text-right"><b>Total Invoice:</b> ${{invoice.total}}</p>
        </div>

        <b-pagination v-if="!pagination" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
        </b-pagination>
    </div>
</div>

</template>

<script>

export default {

    props: {
        invoice: {
            type: Object,
            required: true,
        },
        invoice_items: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Boolean
        }
    },

    data() {
        return {
            currentPage: 1,
            columns: [      
                { key: 'description', label: 'Description', sortable: true },
                { key: 'kp_Record_Number', label: 'Record Number', sortable: true },
                { key: 'price', label: 'Price', sortable: true },
                { key: 'qty', label: 'Quantity', sortable: true }, 
                { key: 'total', label: 'Total', sortable: true }, 
            ]
        }
    },

    computed: {
      rows() {
        return this.invoice_items.length
      },

      perPage() {
        return !this.pagination ? 10 : 100
      }
    },

}

</script>